module.exports = __webpack_public_path__ + "static/media/2.bcb3a543.jpg";